<template>
  <div :class="[
    !subGroup ? 'form-group' : 'form-sub-group',
  ]"
  >
    <h2
      v-if="title && !subGroup"
      class="form-group__title"
    >
      {{ title }}
    </h2>
    <h3
      v-if="title && subGroup"
      class="form-group__title form-group__title--subtitle"
    >
      {{ title }}
    </h3>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormGroup',
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    subGroup: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.form-group {
  margin-bottom: 2.5rem;
  &:last-child {
    margin-bottom: 0;
  }
  &__title {
    font-size: 1.8rem;
    font-family: $font-medium;
    &--subtitle {
      font-size: 1.6rem;
    }
  }
  hr {
    color: $white;
    border: .1rem solid $white;
    margin: 2rem 0;
  }
}
</style>
